module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "case-wrapper",
    class: _vm.shortname + ' ' + _vm.position + ' ' + _vm.loadedState
  }, [(_vm.loadedState === 'not-loaded') ? _c('div', {
    staticClass: "case-loader"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.position === 'right') ? _c('div', {
    staticClass: "col-lg-7"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 align-self-center"
  }, [_c('div', {
    staticClass: "case-inner"
  }, [_c('h3', [_vm._v("\n                        " + _vm._s(_vm.name) + "\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.type) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._t("description")], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "dot1"
  }), _vm._v(" "), _c('div', {
    staticClass: "dot2"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fc2f8ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/case/components/new-case.vue
// module id = 315
// module chunks = 1